import axios from "axios";
import axiosHttp from "@/helpers/api/axiosHttp.js";
import { errorToast, successToast } from "@/helpers/api/toastStyle";

const API = () => {
  const call = async (url) => {
    try {
      const reponsive = await axios.get(`${url}`);
      const data = await reponsive.data;
      return data;
    } catch (err) {
      return
    }
  };

  const get = async (url, responseType = "json") => {
    try {
      const reponsive = await axiosHttp.get(`${url}`, {
        responseType: responseType,
      });
      const data = await reponsive.data;
      return data;
    } catch (err) {
      if (!err?.response?.status) {
        errorToast("");
        return;
      }
      switch (err.response.status) {
        case 404:
          errorToast("404 not found");
          return;
        case "404":
          errorToast("404 not found");
          return err;
        default:
          break;
      }
    }
  };

  const remove = async (url, isSuccessToast = false) => {
    try {
      const response = await axiosHttp.delete(`${url}`);
      // Mã status 200-299: Yêu cầu thành công
      const data = await response.data;
      if (isSuccessToast) {
        successToast(isSuccessToast)
      }
      return { ...data, ok: true };
    } catch (err) {
      console.error(err);
      let temErr = err?.response?.data ?? err;
      return {
        ...temErr,
        ok: false,
      };
    }
  };

  const post = async (url, dataPost, isSuccessToast = false) => {
    try {
      const reponsive = await axiosHttp.post(`${url}`, dataPost);
      const data = await reponsive.data;
      if (isSuccessToast) {
        successToast(isSuccessToast)
      }
      return data;
    } catch (err) {
      console.error(err);
      let temErr = err?.response?.data ?? err;
      return {
        ...temErr,
        ok: false,
      };
    }
  };
  const patch = async (url, dataPost, isSuccessToast = false) => {
    try {
      const reponsive = await axiosHttp.patch(`${url}`, dataPost);
      const data = await reponsive.data;
      if (isSuccessToast) {
        successToast(isSuccessToast)
      }
      return { ...data, ok: true };
    } catch (err) {
      console.error(err);
      let temErr = err?.response?.data ?? err;
      return {
        ...temErr,
        ok: false,
      };
    }
  };
  const put = async (url, dataPost) => {
    try {
      const reponsive = await axiosHttp.put(`${url}`, dataPost);
      const data = await reponsive.data;
      return { ...data, ok: true };
    } catch (err) {
      console.error(err);
      let temErr = err?.response?.data ?? err;
      return {
        ...temErr,
        ok: false,
      };
    }
  };
  return { get, remove, post, call, patch, put };
};

export default API;
